export default __webpack_public_path__ + "static/media/Hair_11_M_C3.eabf2f23.svg";